// Runtime terrain model — matches Brain.h `TERRAIN` enum from Cheshire's
// Brain plugin SDK. The disk format (BMAP) uses a different encoding for
// mined tiles; conversion happens in @bolo2k/bmap.

export const Terrain = {
  Building: 0,
  River: 1,
  Swamp: 2,
  Crater: 3,
  Road: 4,
  Forest: 5,
  Rubble: 6,
  Grass: 7,
  HalfBuilding: 8,
  Boat: 9,
  DeepSea: 10,
  RefBase: 11,
  Pillbox: 12,
  Unknown: 13,
} as const;

export type TerrainCode = (typeof Terrain)[keyof typeof Terrain];

export const TERRAIN_MASK = 0x0f;
export const TERRAIN_TANK_VIS = 0x10;
export const TERRAIN_PILL_VIS = 0x20;
export const TERRAIN_MINE = 0x80;

export function isWet(t: number): boolean {
  const code = t & TERRAIN_MASK;
  return code === Terrain.River || code === Terrain.Boat || code === Terrain.DeepSea;
}

export function hasMine(t: number): boolean {
  return (t & TERRAIN_MINE) !== 0;
}

export function terrainCode(t: number): TerrainCode {
  return (t & TERRAIN_MASK) as TerrainCode;
}
